import { render, staticRenderFns } from "./BaseMessageCard.vue?vue&type=template&id=6517d1ca&scoped=true&"
import script from "./BaseMessageCard.vue?vue&type=script&lang=js&"
export * from "./BaseMessageCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseMessageCard.vue?vue&type=style&index=0&id=6517d1ca&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.2_uesoswnqfrvbmgjykhrr3r374i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6517d1ca",
  null
  
)

export default component.exports